import React, { useEffect, useState } from "react";
import "./TaskAssignment.css";
import {
  // Avatar,
  // AvatarGroup,
  Box,
  Dialog,
  DialogContent,
  Grid,
  IconButton,
  Modal,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";
// import Avatar from '@mui/joy/Avatar';
import { Avatar, AvatarGroup } from '@mui/joy';
import { taskAssign } from "../../config/images";
import { Close, NavigateBefore, NavigateNext } from "@mui/icons-material";
import { useNavigate, useParams } from "react-router-dom";
import dayjs from 'dayjs';
import { getTaskAssignment, getTaskAssignmentDetails } from "../../config/services";
import ImageGallery from "../../components/ImageGallery/ImageGallery";
import translations from "../../config/language";

function clampAvatars(avatars, maxVisible = 3) {
  const totalAvatars = avatars.length;
  const visibleAvatars = avatars.slice(0, maxVisible); // Show only 3
  const surplus = totalAvatars > maxVisible ? totalAvatars - maxVisible : 0; // Extra count

  return { avatars: visibleAvatars, surplus };
}
const TaskDetail = () => {

  const navigate = useNavigate();
  const params = useParams();
  const [reminderModal, setReminderModal] = useState(false);
  const [taskDetails, setTaskDetails] = useState([]);

  const language = process.env.REACT_APP_LANGUAGE;

  const tasks = [
    {
      title: translations[language].taskTitle,
      desc: taskDetails?.title,
    },
    {
      title: "Data Collector",
      desc: taskDetails?.data_collector_name,
    },
    {
      title: "Description",
      desc: taskDetails?.description,
    },
    {
      title: "Region",
      desc: taskDetails?.region_name,
    },
    {
      title: "State",
      desc: taskDetails?.state_name,
    },
    {
      title: "Local Government ",
      desc: taskDetails?.local_government_name,
    },
    {
      title: "Number of farmers",
      desc: taskDetails?.number_of_farmers,
    },
    {
      title: "Deadline",
      desc: dayjs(taskDetails.deadline_of_task).format("DD/MM/YYYY"),
    },
    {
      title: "Status",
      desc: taskDetails?.status == 7 ? "Completed" : "Pending",
    },
  ];

  const taskSub = [
    {
      srNo: "01",
      date: "30/01/2025",
      taskTitle: "Complete Farmer Information Survey",
      register: "05",
      summary: "Farmer has requested additional information about crop...",
      attachments: [
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
      ],
    },
    {
      srNo: "01",
      date: "30/01/2025",
      taskTitle: "Complete Farmer Information Survey",
      register: "05",
      summary: "Farmer has requested additional information about crop...",
      attachments: [
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
        "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
      ],
    },
  ];


  // const images = [
  //   "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
  //   "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
  //   "https://hebbkx1anhila5yf.public.blob.vercel-storage.com/image-x1KxiucLMCUMaAJ3kiJcnGZgkgutMs.png",
  // ];

  const [isGalleryOpen, setIsGalleryOpen] = useState(false);
  const [images, setImages] = useState([]);
  const [imageIndex, setImageIndex] = useState("");

  const fetchData = async () => {

    try {
      const resp = await getTaskAssignmentDetails(params.id);
      if (resp.status == 200) {
        setTaskDetails(resp.data)
      }
    } catch (error) {
      console.log("error", error);
    }
  };

  useEffect(() => {
    fetchData()
  }, []);

  const handleGalleryOpen = (items, index) => {
    setIsGalleryOpen(true);
    setImages(items);
    setImageIndex(index);
  }



  return (
    <>
      <Box className="task-detail-box">
        <Box className="d-flex justify-content-between align-items-center" style={{ flexWrap: "wrap" }}>
          <Box className="d-flex gap-3 img-box" style={{ padding: "25px" }}>
            <img
              src={taskAssign.backArrow}
              alt=""
              style={{ height: "44px", width: "44px", cursor: "pointer" }}
              onClick={() => navigate("/task-assignment")}
            />
            <img
              src={taskAssign.taskDetail}
              alt=""
              style={{ height: "44px", width: "44px" }}
            />
            <Typography variant="h6" gutterBottom>
              {translations[language].taskDetailsView}
            </Typography>
          </Box>
          <Box className="d-flex align-items-center" style={{ flexWrap: "wrap" }}>
            <Typography variant="h6" gutterBottom>
              {translations[language].status}: <b>12/20</b>
            </Typography>
            <button
              className="assign-task-btn"
              style={{ height: "46px" }}
              onClick={() => setReminderModal(true)}
            >
              {translations[language].sendReminder}
            </button>
          </Box>
        </Box>
        <Box className="pt-3">
          <Typography
            variant="body1"
            gutterBottom
            style={{ marginLeft: "20px", color: "#3C4856" }}
          >
            <b>{taskDetails?.data_collector_name}</b>
          </Typography>
          <Grid container className="task-detail-table">
            {tasks.map((task, index) => (
              <React.Fragment key={index}>
                <Grid item xs={12} sm={4} md={4} lg={4} className="grid-item"
                  style={{ borderTop: index === 0 ? "1px solid #D9D9D9" : "", paddingLeft: "25px" }}
                >
                  {task.title}
                </Grid>
                <Grid item xs={12} sm={8} md={8} lg={8} className="grid-item" style={{ borderTop: index === 0 ? "1px solid #D9D9D9" : ""}}>
                  {task.title === "Status" ? (
                    <b style={{ color: task.desc === "Completed" ? "#31A05F" : "inherit" }}>
                      {task.desc}
                    </b>
                  ) : (
                    <b>{task.desc}</b>
                  )}
                </Grid>
              </React.Fragment>
            ))}
          </Grid>

        </Box>
        <Box className="pt-5">
          <Typography
            variant="body1"
            gutterBottom
            style={{ marginLeft: "20px", color: "#3C4856" }}
          >
            <b>{translations[language].tasksReportSubmission}</b>
          </Typography>
          <Box style={{ width: "100%", overflowX: "auto" }}>
            <Table className="task-assign-table task-sub-table">
              <TableHead>
                <TableRow>
                  <TableCell>{translations[language].srNo}</TableCell>
                  <TableCell>{translations[language].date}</TableCell>
                  <TableCell>{translations[language].taskTitle}</TableCell>
                  <TableCell>{translations[language].farmersRegistered}</TableCell>
                  <TableCell>{translations[language].summary}</TableCell>
                  <TableCell>{translations[language].attachments}</TableCell>
                </TableRow>
              </TableHead>
              <TableBody>
                {taskSub.map((task, index) => {
                  const { avatars, surplus } = clampAvatars(task.attachments, 3);

                  return (<TableRow key={index}>
                    <TableCell style={{textAlign: "center"}}>{task.srNo}</TableCell>
                    <TableCell>{task.date}</TableCell>
                    <TableCell>{task.taskTitle}</TableCell>
                    <TableCell>{task.register}</TableCell>
                    <TableCell>{task.summary}</TableCell>
                    <TableCell>
                      <AvatarGroup sx={{ "--AvatarGroup-gap": "-16px" }}>
                        {avatars.map((attachment, i) => (
                          <Avatar
                            key={i}
                            className="cursor-pointer"
                            style={{ cursor: "pointer" }}
                            sx={{ width: 35, height: 35 }}
                            onClick={() => handleGalleryOpen(task.attachments, i)}
                          >
                            <img
                              src={attachment || "/placeholder.svg"}
                              alt={`Attachment ${i + 1}`}
                              style={{
                                width: 35,
                                height: 35,
                                objectFit: "cover",
                              }}

                            />
                          </Avatar>
                        ))}
                        {surplus > 0 &&
                          <Avatar
                            sx={{
                              width: 35,
                              height: 35,
                              backgroundColor: "#3C4856",
                              color: "#FFFFFF",
                              fontSize: 14,
                              fontWeight: 400,
                              cursor: "pointer"
                            }}
                            onClick={() => handleGalleryOpen(task.attachments, 3)} // start from 4th index as preview
                          >
                            +{surplus}
                          </Avatar>}
                      </AvatarGroup>
                    </TableCell>
                  </TableRow>
                  )
                })}
              </TableBody>
            </Table>
          </Box>

        </Box>

        <Dialog
          open={reminderModal}
          onClose={() => setReminderModal(false)}
          maxWidth="xs"
          fullWidth
          disableScrollLock
          PaperProps={{
            sx: { borderRadius: "12px" },
          }}
        // className="dialog-assign"
        >
          <div className="assign-div">
            {" "}
            <div className="d-flex justify-content-around align-items-center">
              <h5
                className="p-3 mb-0"
                style={{ textAlign: "center", marginLeft: "100px" }}
              >
                {translations[language].sendReminder}
              </h5>
              <img
                src={taskAssign.closeIcon}
                alt=""
                style={{
                  height: "30px",
                  width: "30px",
                  cursor: "pointer",
                  marginLeft: "85px",
                }}
                onClick={() => setReminderModal(false)}
              />
            </div>
          </div>
          <DialogContent>
            <form noValidate autoComplete="off">
              <TextField
                fullWidth
                label={translations[language].enterReminderTitle}
                name="taskTitle"
                // value={taskData.taskTitle}
                // onChange={handleChange}
                className="mb-3"
              />
              <TextField
                fullWidth
                id="outlined-multiline-static"
                label={translations[language].description}
                name="taskDescription"
                multiline
                // value={taskData.taskDescription}
                // onChange={handleChange}
                className="textarea-taskDescription mb-3"
                rows={3}
              />

              <button
                className="assign-task-button"
              // onClick={handleSubmit}
              >
                {translations[language].sendReminder}
              </button>
            </form>
          </DialogContent>
        </Dialog>


        {isGalleryOpen &&
          <ImageGallery
            images={images}
            isOpen={isGalleryOpen}
            onClose={() => setIsGalleryOpen(false)}
            imageIndex={imageIndex}
          />

        }
      </Box>
    </>
  );
};
export default TaskDetail;
